var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Caption from "./Caption";
import Icon from "./Icon";
import Text from "./Text";
import React, { useState } from 'react';
import { space, typography } from 'styled-system';
import { css, styled } from "../utils";
var CircleButton = styled.div(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    border: 2px solid ", ";\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    margin-left: 0.5rem;\n    cursor: pointer;\n  "], ["\n    background: ", ";\n    border: 2px solid ", ";\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    margin-left: 0.5rem;\n    cursor: pointer;\n  "])), colors.white, colors.primary);
});
var Arrow = styled(Icon.Arrow)(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    transform: rotate(90deg);\n    transition-duration: 0.5s;\n    transition-property: transform;\n    path {\n      fill: ", ";\n    }\n    &.open {\n      transform: rotate(-90deg);\n    }\n  "], ["\n    transform: rotate(90deg);\n    transition-duration: 0.5s;\n    transition-property: transform;\n    path {\n      fill: ", ";\n    }\n    &.open {\n      transform: rotate(-90deg);\n    }\n  "])), colors.primary);
});
var StyledPriceRow = styled.div(function () { return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 1rem 0;\n  "], ["\n    margin: 1rem 0;\n  "]))); }, typography, space);
var StyledWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: column-reverse;\n  align-items: flex-start;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: column-reverse;\n  align-items: flex-start;\n"])));
var Label = styled(Text)(function (_a) {
    var font = _a.theme.font;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin: 0;\n    font-weight: ", ";\n  "], ["\n    margin: 0;\n    font-weight: ", ";\n  "])), font.weight.semiBold);
});
var Price = styled(Label)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex: 1;\n  white-space: nowrap;\n  text-align: right;\n  margin-left: 0;\n"], ["\n  flex: 1;\n  white-space: nowrap;\n  text-align: right;\n  margin-left: 0;\n"])));
var ProdcutPriceRow = function (_a) {
    var label = _a.label, value = _a.value, caption = _a.caption, className = _a.className, details = _a.details, props = __rest(_a, ["label", "value", "caption", "className", "details"]);
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    return (React.createElement(StyledPriceRow, __assign({ "data-component": "ProductPriceRow", className: className }, props),
        React.createElement(StyledWrapper, null,
            React.createElement(Label, null, label),
            details && (React.createElement(CircleButton, { onClick: function () { return setIsOpen(function (prev) { return !prev; }); } },
                React.createElement(Arrow, { className: isOpen ? 'open' : 'close' }))),
            React.createElement(Price, null, value)),
        isOpen &&
            details.map(function (item) { return (React.createElement(StyledWrapper, { key: item.label },
                React.createElement(Label, null, item.label),
                React.createElement(Price, { mt: "small" }, item.value))); }),
        caption && (React.createElement(Caption, { mb: 0, mt: "4px", light: true }, caption))));
};
export default ProdcutPriceRow;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=ProductPriceRow.js.map